import { RouterProvider } from 'react-router-dom'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'

import { Toaster } from 'shadcdn/ui/toaster'
import { useAuthStore } from 'features/auth/useAuthStore'
import { InstalledSoftwareTracker } from 'features/installed-software/InstalledSoftwareTracker' // eslint-disable-line @typescript-eslint/no-unused-vars
import { useInitAnalytics } from 'features/analytics/analytics'

import { OpenAPI } from './openapi'
import { router } from './router'
import { CONFIG } from './config'

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } })

OpenAPI.BASE = CONFIG.API_BASE_URL

function App() {
  const initAuth = useAuthStore((state) => state.initAuth)
  useEffect(() => void initAuth(), [initAuth])
  useInitAnalytics()

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <Helmet></Helmet>
        <InstalledSoftwareTracker />
        <RouterProvider router={router} />
        <Toaster />
      </HelmetProvider>
    </QueryClientProvider>
  )
}

export default App
